import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { handleError } from "../../utils";
import http from "../../core/service/http";
import { useNavigate } from "react-router-dom";

export const useFirstViewHook = () => {

    const navigate = useNavigate();
      const [isLoading, setLoading] = useState(false);
      const [showPassword, setShowPassword] = useState(false);
      const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    
      const initialValues = {
        member_id: "",
        token: "",
        firstName: "",
        lastName: "",
        password: "",
        confirmPassword: "",
        email: "",
        confirmEmail: "",
        phone: "",
      };
    
      const validationSchema = Yup.object({
        member_id: Yup.string().required("Member ID is required."),
        token: Yup.string().required("Token number is required."),
        firstName: Yup.string().required("First name is required."),
        lastName: Yup.string().required("Last name is required."),
        password: Yup.string()
          .min(6, "Password must be at least 6 characters")
          .required("Password is required."),
        confirmPassword: Yup.string()
          .oneOf([Yup.ref("password"), null], "Passwords must match")
          .required("Confirm password is required."),
        email: Yup.string()
          .email("Invalid email format")
          .required("Email is required."),
        confirmEmail: Yup.string()
          .email("Invalid email format")
          .oneOf([Yup.ref("email"), null], "Emails must match")
          .required("Confirm email is required."),
        phone: Yup.string()
          .required("Phone number is required."),
      });
    
      const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
      };
    
      const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
      };
    
      const handleNavigate = () => {
        navigate("/");
      };
    


    return{
        isLoading,
        setLoading,
        validationSchema,
        initialValues,
        showPassword,
        setShowPassword,
        showConfirmPassword,
        setShowConfirmPassword,
        togglePasswordVisibility,
        toggleConfirmPasswordVisibility,
        handleNavigate,
    };
}